/** Motion helpers shared by the rebooking picker views. */
import { Platform, ViewStyle } from "react-native"

/** Honors the OS "reduce motion" setting on web; everywhere else motion stays on. */
export function prefersReducedMotion(): boolean {
  if (Platform.OS !== "web" || typeof window === "undefined") return false
  try {
    return !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
  } catch {
    return false
  }
}

/** CSS transition for web-only properties RN's ViewStyle does not type. */
export function webTransition(property: string, ms: number): ViewStyle {
  if (Platform.OS !== "web") return {}
  return {
    transitionProperty: property,
    transitionDuration: prefersReducedMotion() ? "0ms" : `${ms}ms`,
  } as ViewStyle
}
